import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import EditTicketForm from 'src/components/Forms/EditTicketForm';

const EditTicketModal = () => (
  <ModalBase
    name={MODALS.editTicket}
    size={MODALS_SIZE.medium}>
    <EditTicketForm />
  </ModalBase>
);

export default EditTicketModal;
